import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  START_FETCH = "START_FETCH",
  FINISH_FETCH = "FINISH_FETCH"
}

export interface FetchStatusAction extends ResKaReduxAction {
}

export const startFetch = (): FetchStatusAction => ({
  type: ACTION_TYPE.START_FETCH
});

export const finishFetch = (): FetchStatusAction => ({
  type: ACTION_TYPE.FINISH_FETCH
});